import http from "../http";
import type { DocumentCategory } from "../documents";

/** Het uploadregister (I18, WP3), zie backend/src/upload-batches. */
export type UploadBestandStatus =
  | "WACHT"
  | "BEZIG"
  | "KLAAR"
  | "OVERGESLAGEN"
  | "MISLUKT";

export interface NieuwBatchBestand {
  relatiefPad: string;
  naam: string;
  grootte: number;
  /** File.lastModified in ms (bij een cd: het laatste van zijn bestanden). */
  laatstGewijzigdOp?: number;
  category?: DocumentCategory;
  folderPath?: string;
  cdZip?: boolean;
}

export interface UploadBatchBestandStand {
  id: string;
  relatiefPad: string;
  naam: string;
  grootte: number;
  laatstGewijzigdOp: number | null;
  category: DocumentCategory | null;
  folderPath: string | null;
  cdZip: boolean;
  status: UploadBestandStatus;
  uploadUrl: string | null;
  blobName: string | null;
  geuploadBytes: number;
  documentId: string | null;
  fout: string | null;
}

export interface UploadBatchStand {
  id: string;
  aangemaaktOp: string;
  status: "BEZIG" | "KLAAR" | "GESTOPT";
  bestanden: UploadBatchBestandStand[];
}

export interface BestandWijziging {
  status?: UploadBestandStatus;
  uploadUrl?: string;
  blobName?: string;
  geuploadBytes?: number;
  documentId?: string;
  fout?: string;
}

const basis = (kenmerk: string) => `/records/${kenmerk}/uploads`;

/**
 * Het vastleggen van een batch (tot 200 rijen in één transactie) hangt nooit
 * stil: daarna een gewone fout met een melding (trein 51, L4).
 */
export const REGISTREER_TIMEOUT_MS = 90_000;

export interface NieuweUploadBatch {
  batchId: string;
  aangemaaktOp: string;
  bestanden: { id: string; status: UploadBestandStatus }[];
}

export async function maakUploadBatch(
  kenmerk: string,
  bestanden: NieuwBatchBestand[],
): Promise<NieuweUploadBatch> {
  const { data } = await http.post<NieuweUploadBatch>(
    basis(kenmerk),
    { bestanden },
    { timeout: REGISTREER_TIMEOUT_MS },
  );
  return data;
}

export async function haalUploadBatch(
  kenmerk: string,
  batchId: string,
): Promise<UploadBatchStand> {
  const { data } = await http.get<UploadBatchStand>(
    `${basis(kenmerk)}/${batchId}`,
  );
  return data;
}

export async function werkBestandBij(
  kenmerk: string,
  batchId: string,
  bestandId: string,
  wijziging: BestandWijziging,
): Promise<void> {
  await http.patch(
    `${basis(kenmerk)}/${batchId}/bestanden/${bestandId}`,
    wijziging,
  );
}

export async function stopUploadBatch(
  kenmerk: string,
  batchId: string,
): Promise<void> {
  await http.post(`${basis(kenmerk)}/${batchId}/stop`);
}
